import moment from "moment";
import { createSelector } from "reselect";
import { descSortCompare } from "~/utils/utils.jsx";

export const getAllUsersInternalRates = (state) => {
  return state.user_internal_rates ? state.user_internal_rates.toList().toJS() : [];
};

export const makeGetCurrentUserInternalRate = () => {
  return createSelector(
    getAllUsersInternalRates,
    (state, userId) => userId,
    (usersInternalRates, userId) => {
      const now = moment().unix();
      const rates = usersInternalRates
        .filter((internalRate) => {
          return internalRate.user_id === userId;
        })
        .sort((a, b) => descSortCompare(a.valid_from, b.valid_from));

      if (rates.length > 1) {
        const currentRate = rates.find((rate) => rate.valid_from <= now);
        return currentRate?.rate;
      }
      return rates && rates[0]?.valid_from <= now ? rates[0].rate : null;
    }
  );
};

export const getRatesByUser = createSelector(
  getAllUsersInternalRates,
  (state, userId) => userId,
  (allRates, userId) =>
    allRates.filter((rate) => rate.user_id === userId).sort((a, b) => descSortCompare(a.valid_from, b.valid_from))
);

export const getUserInternalRateForSpecifiedUserAndDate = () =>
  createSelector(
    (state, userId) => getRatesByUser(state, userId),
    (state, userId, forDate) => forDate,
    (userInternalRates, forDate) => {
      const rate = userInternalRates.find((internalRate) => {
        const chosenDate = moment(forDate).format(`YYYY-MM-DD`);
        const reduxDate = moment.unix(internalRate.valid_from).format(`YYYY-MM-DD`);
        return reduxDate === chosenDate;
      });
      return rate ? rate.rate : null;
    }
  );
